import jQuery from 'jquery';

function Ctrl($scope, $state, $rootScope, $timeout, $stateParams, AuthService, UserService, promoService, utilsService, modalService) {
  if ($rootScope.currentUser) {
    if ($scope.config.success) {
      $scope.config.success($rootScope.currentUser);
    } else {
      $state.go('app.me.profile');
    }
  }

  $scope.config.currentState = $scope.config.startState || 'existingUser';
  $scope.config.promo = resolvePromo();

  $scope.isMobile = function() {
    return jQuery(window).width() < 768;
  };

  $scope.done = function(response, err) {
    if (err) {
      $scope.error = utilsService.errorMessage(response);
      loading(false);
      return;
    }

    $rootScope.$broadcast('login');

    if ($scope.config.promo) {
      redeemPromo(response.user, function() {
        UserService.me();

        verifyUser(response.user);
      }, function() {
        verifyUser(response.user);
      });
    } else {
      verifyUser(response.user);
    }
  };

  function verifyUser(user) {
    if ($scope.config.completeProfile === false) {
      $scope.config.success(user);

      return;
    }

    const isNewAccount = utilsService.isNewUser(user);
    const isFacebookLogin = $scope.config.facebookLogin;

    if (!isNewAccount) {
      $scope.config.success(user);

      return;
    }

    const keysToVerify = (isFacebookLogin) ? ['firstName', 'lastName', 'email', 'phone'] : ['phone'];

    $scope.config.success(user);

    modalService.completeProfile({
      keysToVerify: keysToVerify
    }, function() {}, function() {});
  }

  function resolvePromo() {
    let promo = $stateParams.code;

    promo = ($scope.config.promo) ? $scope.config.promo : promo;

    return promo;
  }

  function redeemPromo(user, success, error) {
    const promoCode = $scope.config.promo;

    promoService.redeem(promoCode).$promise.then(success, error);
  }

  function loading(status) {
    if (status) {
      $scope.error = null;
    }
    $scope.loading = status;
  }
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$rootScope',
  '$timeout',
  '$stateParams',
  'tl.auth.service',
  'tl.user.service',
  'tl.promo.service',
  'utilsService',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/login/controller.js